import { render, staticRenderFns } from "./classdetailsListBj.vue?vue&type=template&id=ac1c912c&scoped=true"
import script from "./classdetailsListBj.vue?vue&type=script&lang=js"
export * from "./classdetailsListBj.vue?vue&type=script&lang=js"
import style0 from "./classdetailsListBj.vue?vue&type=style&index=0&id=ac1c912c&prod&lang=less&scoped=true"
import style1 from "./classdetailsListBj.vue?vue&type=style&index=1&id=ac1c912c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1c912c",
  null
  
)

export default component.exports